import { IHQ } from './HQ';

export interface IPublication {
  location_code: string;
  desired_commit_id: string;
  published_commit_id: string;
  config: null;
  created_at: string;
  modified_at: string;
  hq: IHQ;
}

export interface IPublications {
  last_published_at: string;
  last_modified_at: string;
}

export enum PublicationTypes {
  FULL = 'full',
  CONTENTS = 'contents',
  PRODUCTS = 'products',
  DAYPARTS = 'dayparts',
  OVERRIDES = 'overrides',
}
